import { useParams } from "react-router-dom";
import { useState } from "react";
import ModalEditSelectType2 from "../../../../components/modal/modalEditSelectType2";
import { detailTrainingNewParticipant } from "../../../../config/apiSPA";
import ModalInfo from "../../../../components/modal/modalInfo";
const modalOptions = {
  title: "Participant List",
  text: "Select a training participant from the list and add a remark, if any.",
};
const infoModalInitialState = { show: false, title: "", text: "", theme: "" };
function TrainingParticipantToolbar({ onChange = () => {} }) {
  const { id } = useParams();
  const [addParticipantModal, setAddParticipantModal] = useState(false);
  const [infoModal, setInfoModal] = useState(infoModalInitialState);
  const handleClickAddParticipant = () => {
    setAddParticipantModal(true);
  };
  const handleSubmitParticipant = async ({ val, textVal }) => {
    setAddParticipantModal(false);
    try {
      const payload = { trainingId: id, manpowerId: val, remark: textVal };
      const res = await detailTrainingNewParticipant(payload);
      onChange(res.data);
    } catch (error) {
      setInfoModal({
        show: true,
        title: "Error",
        text: `Failed to edit : ${error.message}`,
        theme: "danger",
      });
    }
  };
  return (
    <>
      <div className="mb-2">
        <div className="d-block d-lg-flex align-items-center">
          <span onClick={handleClickAddParticipant} className="btn btn-outline-theme me-2 mb-1">
            <i className="fa fa-fw fa-plus"></i>
            <span>Add Part..</span>
          </span>
        </div>
      </div>
      <ModalEditSelectType2 show={addParticipantModal} onHide={() => setAddParticipantModal(false)} submitClick={handleSubmitParticipant} options={modalOptions} selector="manpower" />
      <ModalInfo show={infoModal.show} theme={infoModal.theme} text={infoModal.text} title={infoModal.title} onHide={() => setInfoModal(infoModalInitialState)} clicked={() => setInfoModal(infoModalInitialState)} />
    </>
  );
}
export default TrainingParticipantToolbar;
